
import { jwtDecode } from 'jwt-decode';

export default {
    get_api_url(state) {
        return state.api_url;
    },
    // Admin
    get_token(state) {
        return state.api_token;
    },
    isAuthenticated(state, getters) {
        if (!getters.get_token) return false;
        const decoded = getters.getTokenData;
        if (!decoded) return false;

        const nowInSeconds = Math.floor(Date.now() / 1000);
        if (decoded.exp < nowInSeconds) {
            return false;
        } else {
            return true;
        }
    },
    getTokenData(_state, getters) {
        if (!getters.get_token) return null;
        try {
            return jwtDecode(getters.get_token);
        } catch (e) {
            return null;
        }
    },
    getAdminPosition(_state, getters) {
        return getters.getTokenData?.position;
    },
    getUserInitials(_state, getters) {
        if (!getters.getTokenData) return '-';
        else if (Object.keys(getters.getTokenData).length > 0) {
            const firstname_initial = getters.getTokenData?.firstname?.split('')[0];
            const lastname_initial = getters.getTokenData?.lastname?.split('')[0];
            const initials = firstname_initial + lastname_initial;
            return initials?.toUpperCase();
        } else {
            return '-';
        }
    },
    getUserId(_state, getters) {
        return getters.getTokenData?.adminId;
    },
    // Autorisations
    getPublicRoutes(state) {
        return state.public_routes;
    },
    getAdminRoutes(state) {
        return state.admin_routes;
    },
    isSuperAdmin(_state, getters) {
        return getters.getTokenData?.is_super_admin;
    },
}